'use client';
import React, { useRef, useState } from 'react';

import UsedCarSearchQuery from '@/app/used-cars/search/_components/UsedCarSearchQuery';

import { FiltersCounter } from '../../filters/mobile-filters-counter/mobile-filters-counter';
import { FilterTagList } from '../filter-tag-list/filter-tag-list';

import styles from './main-search.module.scss';

export const MainSearch: React.FC<{
  noTags?: boolean;
}> = ({ noTags = false }) => {
  const [filtersVisible, setFiltersVisible] = useState(false);
  const searchRef = useRef<any>();

  return (
    <div ref={searchRef} className={styles.mainSearchWrapper}>
      <div className={styles.mainSearch}>
        <UsedCarSearchQuery />
        <div className={styles.desktopFilters}>
          <FiltersCounter
            setFiltersVisible={setFiltersVisible}
            filtersVisible={filtersVisible}
            noTags={noTags}
          />
        </div>
        <div className={styles.mobileTagList}>
          <FilterTagList noTags={noTags} />
        </div>
      </div>
      {filtersVisible && (
        <div className={styles.desktopFilters}>
          <FilterTagList noTags={noTags} />
        </div>
      )}
    </div>
  );
};
